import { useEffect, useState } from 'react' 

export default function PricingToggle({ onUpdate, minPadding }) {
  const [selected, setSelected] = useState('quarterly');

  useEffect(() => {
    onUpdate(selected);
  }, [selected]);

  return (
    <div className={`flex items-center justify-center ${minPadding ? '' : 'h-[100px]'} mb-6`}>
      <div className="inline-flex bg-gray-200 rounded-full p-1">
      <button
        onClick={() => setSelected('monthly')}
        className={`px-6 py-2 rounded-full text-sm font-medium transition-all ${
        selected === 'monthly'
          ? 'bg-white text-gray-900 shadow-sm'
          : 'text-gray-600'
        }`}
      >
        Monthly
      </button>
      
      <button
        onClick={() => setSelected('quarterly')}
        className={`px-6 py-2 rounded-full text-sm font-medium transition-all ${
        selected === 'quarterly'
          ? 'bg-indigo-600 text-white shadow-sm'
          : 'text-gray-600'
        }`}
      >
        Quarterly — Save 20%
      </button>
      </div>
    </div>
  );
}